// Inventario de materiales (traído del prototipo): entradas por compras y consumo calculado con la fórmula de cada
// prenda de los pedidos que cuentan como venta. Los servicios no tienen inventario. Funciones puras, con pruebas.
import { promediosDeCompra, type Compra } from './costeo';

export interface MaterialInv { codigo: string; nombre: string; tipo: 'Material' | 'Servicio'; unidad: string; stock_minimo: number | null; categoria_id: number | null }
export type Alerta = '' | 'Sin compras' | 'Saldo negativo' | 'Reponer';
export interface Existencia { m: MaterialInv; entradas: number; consumo: number; saldo: number; cpp: number; valor: number; alerta: Alerta }

export function existencias(materiales: MaterialInv[], compras: Compra[], formula: { sku: string; codigo: string; cantidad: number | null }[], lineas: { sku: string; cantidad: number }[]): Existencia[] {
  const cpp = promediosDeCompra(compras), entradas = new Map<string, number>(), consumo = new Map<string, number>();
  for (const c of compras) entradas.set(c.codigo, (entradas.get(c.codigo) || 0) + (+c.cantidad || 0));
  const porSku = new Map<string, { codigo: string; cantidad: number | null }[]>();
  for (const r of formula) { if (!porSku.has(r.sku)) porSku.set(r.sku, []); porSku.get(r.sku)!.push(r); }
  const tipo = new Map(materiales.map(m => [m.codigo, m.tipo]));
  for (const l of lineas) for (const r of porSku.get(l.sku) || []) {
    if (tipo.get(r.codigo) !== 'Material') continue;
    consumo.set(r.codigo, (consumo.get(r.codigo) || 0) + (+l.cantidad || 0) * (+(r.cantidad ?? 0) || 0));
  }
  return materiales.filter(m => m.tipo === 'Material').map(m => {
    const e = entradas.get(m.codigo) || 0, cons = consumo.get(m.codigo) || 0, s = e - cons, u = cpp.get(m.codigo) || 0;
    const alerta: Alerta = e === 0 ? 'Sin compras' : s < 0 ? 'Saldo negativo' : s < (+(m.stock_minimo ?? 0) || 0) ? 'Reponer' : '';
    return { m, entradas: e, consumo: cons, saldo: s, cpp: u, valor: Math.max(s, 0) * u, alerta };
  });
}

// Una compra: el IVA de la factura y lo que entra al costo del material (con IVA mientras el negocio no lo cruce).
export function valoresCompra(valorAntesIva: number, pctIva: number, ivaDescontable: boolean) {
  const iva = (+valorAntesIva || 0) * (+pctIva || 0), total = (+valorAntesIva || 0) + iva;
  return { iva, total, costeo: ivaDescontable ? +valorAntesIva || 0 : total };
}

// Código del insumo nuevo: el siguiente MAT-0xx o SRV-0xx.
export function siguienteCodigoInsumo(codigos: string[], tipo: 'Material' | 'Servicio') {
  const pref = tipo === 'Servicio' ? 'SRV-' : 'MAT-';
  const n = codigos.filter(c => c.startsWith(pref)).reduce((m, c) => Math.max(m, +c.slice(4) || 0), 0) + 1;
  return pref + String(n).padStart(3, '0');
}
